const KwToHPMultiplier = 1.35962;

/**
 * Convert kilowatts to horsepower
 * @param kw - Kilowatts
 * @returns Horsepower
 */
export const convertKwToHP = (kw: number): number => Math.round(kw * KwToHPMultiplier);
